module.exports = __webpack_public_path__ + "static/media/background-blue.1059b160.svg";